
"use strict";

//import { TextureLoader } from '../../../../src/js/three.module.js';
import { getTextureLoader } from '../../../utils/loaders/loader-manager.js';

import { ObjectLoader } from '../../../utils/object-loader.js';
import { ObjectPropertyHandler } from '../../../utils/object-properties/object-property-handler.js';

export class GameSceneControlsStateComponentController {

	static $inject = ["$scope","$timeout","gettextCatalog","additionalObjectService","gameSceneService","userActionHistoryService","wallsHandlerService","Notification","$playerHandler","$uibModal","$q","entitySelectionService","contextMenuService","HUDService","spherical360SetupService","objectNamingService"];

	constructor(  $scope,  $timeout,  gettextCatalog,  additionalObjectService,  gameSceneService,  userActionHistoryService,  wallsHandlerService,  Notification,  $playerHandler,  $uibModal,  $q,  entitySelectionService,  contextMenuService,  HUDService,  spherical360SetupService,  objectNamingService ) {

		$scope.objectMoveable = ObjectPropertyHandler.moveable;

		$scope.HUDService = HUDService;
		$scope.spherical360SetupService = spherical360SetupService;

		$scope.oeuvresCtrl = null;
		$scope.offsetTop = 0;
		$scope.style_content_max_height = Infinity;
		$scope.noTopOffset = true;

		$scope.$watch(function(){
			var elem = document.getElementById("oeuvres-list");
			return elem && elem.offsetHeight;
		}, function(val){
			$scope.offsetTop = val + 20;
			try {
				var e_container = document.querySelector("#controls-panel");
				var e_items     = document.querySelectorAll("#controls-panel ol > li > header");

				if (e_container) {
					$scope.style_content_max_height = e_container.clientHeight - $scope.offsetTop;
					for( var i = 0; i < e_items.length; i++ ) $scope.style_content_max_height -= e_items[i].clientHeight;
				}
			} catch(e){ }
		});

		$scope.entitySelectionService = entitySelectionService;
		$scope.gameSceneService = gameSceneService;
		$scope.additionalObjectService = additionalObjectService;
		$scope.contextMenuService = contextMenuService;
		$scope.objectNamingService = objectNamingService;
		var wallsHandler = $scope.wallsHandler = wallsHandlerService;
		$scope.walls = wallsHandlerService.walls;
		$scope.paintingTool = window.paintingTool;
		$scope.open = !$playerHandler.getConfig( "view.game-scene.controls/controls-collapsed" );

		$scope.items_open = { "walls":false, "oeuvres":false, "painting_tool":false, "additional_objects":false, "tools":false, "view":false, "comments":false, "spherical360Setups":false };

		for (var _key in $scope.items_open) {
			if ($playerHandler.getConfig( "view.game-scene.controls-item-" + _key + "-open" )) {
				$scope.items_open[ _key ] = $scope.ọpen = true;
			}
		}

		$scope.getTopOffset = function(){ return HUDService.oeuvrePanelHeight(); };

		$scope.handleTitleClick = function( key ){
			var item_open;
			if ( $scope.open ){
				for( var i in $scope.items_open ){
					if( i == key ){
						item_open = $scope.items_open[i] = !$scope.items_open[i];
					} else {
						$scope.items_open[i] = false;
					}
				}
			} else {
				for( var i in $scope.items_open ){
					$scope.items_open[i] = (i == key);
				}
			}

			// Huolehditaan, että valikko aukeaa, tai sulkeutuu jos on auki ja klikattu opening-nappia
			var _open = $scope.open;
			$scope.open = !($scope.open && key == "opening");


			// Tallennetaan asetukset
			if (_open != $scope.open) $playerHandler.setConfig( "view.game-scene.controls/controls-collapsed", !$scope.open );

			for (var _key in $scope.items_open) {
				$playerHandler.setConfig( "view.game-scene.controls-item-" + _key + "-open", !!$scope.items_open[ _key ] );
			}

			/** Mahdolliset toimintokohtaiset hommat */
			switch( key ){
				case "opening":
					break;
				case "oeuvres":
					break;
				case "walls":
					break;
				case "painting_tool":
					if ( item_open === true  ) $scope.paintingTool.start();
					if ( item_open === false ) $scope.paintingTool.stop();
					break;
			}
		};

		$scope.backToSelection = function(){
			var uid = gameSceneService.arrangement && gameSceneService.arrangement.uid;
			location.href = "#!/arrangements?"+ (uid?"arrangement_uid="+uid:"");
		};

		$scope.openPlayerSettingsModal = function(){ $rootScope.openPlayerSettingsModal().finally(function(v){
			try {
				var settings = player.getOpts();
				window.localStorage.setItem( "model-preview/player-settings", JSON.stringify( settings ));
				console.log( "Saved player settings to localStorage", settings );
			} catch( err ){ console.error( err ); }
		})};

		$scope.openViewSettings = function( $event ){
			contextMenuService.run( 'player', $event.clientX, $event.clientY, {});
		}

		$scope.serveScreenshot = function( filename, equirectangular ){

			var imagePrms = equirectangular ? gameSceneService.getEquirectangularScreenshot() : gameSceneService.getScreenshot();

			imagePrms.then(function( img ) {

				if (!filename) {
					filename = prompt( "Insert a name for the downloadable capture", getFilename( ));
				}

				if (!filename) return console.warn( "Downloading a capture cancelled." );

				if (filename.substr( -4 ) != ".png") filename += ".png";

				/**/

				var a = document.createElement( 'a' );
				a.href = img.src;
				a.download = filename;

				document.body.appendChild( a );
				a.click();
				document.body.removeChild( a );

			}).catch(function( error ){

				console.error( error );

				Notification.error({
					title   : "Failed to generate and download screenshot",
					message : error.toString()
				});
			});

			function getFilename(){
				return "screenshot";
			}
		};

		$scope.save = function(){
			return gameSceneService.save( gameSceneService.arrangement ).then(function( response ){
				console.log( response );
				Notification.success( "Saved!" );
			}).catch(function( err ){
				console.error( err );
				Notification.error({ title: "Failed to save", message: err.data && err.data.str });
			});
		};

		/*********** ADDITIONALOBJECTS ***********/

		$scope.genUnnamedObjectTitle = function( obj ) {
			var key;
			if (obj.type == "cube") {
				key = "cube";
				if (obj.size.x.toFixed(3)+obj.size.y.toFixed(3)+obj.size.z.toFixed(3) == "0.2100.2950.001") key = "cube.a4";
			} else if (obj.type == "json") {
				if (obj.opts.source == "url")             key = "json.url";
				else if (obj.opts.source == "attachment") key = "json.attachment";
				else if (obj.mesh.type == "Object3D")     key = "json.Object3D";
			} else if (obj.type == "light") {
				key = "light." + obj.mesh.type;
			}

			return key ? gettextCatalog.getString( "label:additionalObject."+key ) : obj.mesh.type;
		}

		$scope._addit_obj_width  = 1;
		$scope._addit_obj_height = 1;
		$scope._addit_obj_depth  = 1;
		$scope._addit_obj_color  = "#ffffff";
		$scope._addit_obj_creating = false;
		
		$scope.generateAdditional = function doGenerateAdditional( type, args ) {
			var object;

			var position = new THREE.Vector3( 0, 0, -1 ).applyEuler( $playerHandler.player.camera.rotation );

			var first = getIntersects( $playerHandler.player.headPos, position )[0];

			if (first) position.multiplyScalar( Math.min( 4, first.distance / 2 ));

			position.add( $playerHandler.player.headPos );

			var rotation = new THREE.Euler( 0, $playerHandler.player.av, 0 );

			switch (type) {

				case 'text':

					var [ width, height, text ] = args;
					object = userActionHistoryService.do( "additionalObject.text.create", width, height, text, position, rotation );
					break;

				case 'plane':

					var [ width, height, clr ] = args;
					object = userActionHistoryService.do( "additionalObject.plane.create", width, height, clr, position, rotation );
					break;

				case 'cube':

					object = userActionHistoryService.do( "additionalObject.cube.create", args[0], args[1], args[2], args[3] );
					break;

				case 'sphere':
					object = additionalObjectService.generateSphere( args[0], new THREE.Color( args[1] ));
					object.mesh.position.copy( position );

					break;

				case 'json':

					var json = args[0];
					var opts = args[1] || {};

					object = userActionHistoryService.do( "additionalObject.json.create", json, null, null, opts );

					switch (object.opts.source = opts.source) {
						case "json":
							break;
						case "url":
							object.opts.source_url = opts.source_url;
							break;
						case "attachment":
							object.opts.attachment_uid = opts.attachment_uid;
							break;
						default:
							delete object.opts.source; // Estetään tallentaminen näin
					}

					break;

				case 'light':

					object = userActionHistoryService.do( "additionalObject.light.create", args[0] );

					break;
				default:
					return;
			}

			additionalObjectService.selectObject( object );

			Notification.success( gettextCatalog.getString( "Object created!" ));

			$scope._addit_obj_creating = false;

			return object;
		};

		$scope.cloneObject = function( object ){

			additionalObjectService.duplicateObject( object );

		};

		/**
		 * Asetetaan pelaajahahmo katsomaan objektia kohti
		 */
		$scope.lookAtObject = function( object ){

			additionalObjectService.selectObject( object );

			$playerHandler.player.adjustToLookMesh( object.mesh, 1 );

		};


		/**
		 * Luodaan maailmaan uusi objekti
		 */
		$scope.initAdditObj = function( key ) {

			var obj = additionalObjectService.templates[ key ];

			if (obj) {

				return $q.when( $scope.initAdditObjByTemplate( obj ))
				.then(function( obj ){

					obj.template = key;

					return obj;
				})
				.catch(function( error ){
					console.error( error );

					Notification.error({
						"title"   : "Failed to add object",
						"message" : error.toString()
					});
				});
			}


			switch (key) { 
				case "a4":
					return $scope.generateAdditional( 'plane', [ .21, .297, 0xffffff ]);
					break;
				case "cube":
					$scope._addit_obj_creating = 'cube'
					$scope._addit_obj_width  = 1;
					$scope._addit_obj_height = 1;
					$scope._addit_obj_depth  = 1;
					break;
				case false:
					$scope._addit_obj_creating = false;
					break;
				default:
					console.error( "initAdditObj :: Invalid key '"+ key +"'" );
			}
		};


		/**
		 * Luodaan maailmaan uusi objhekti perustuen Malliin asetettuun Mallineeseen
		 */
		$scope.initAdditObjByTemplate = function( template ) {

			var obj = template, ret;

			switch (obj.type) {

				case "plane":
					let material = "#ffffff", { width, height, texture_img_url } = obj;
					
					if (texture_img_url) {
						material = { texture_img_url };
					}

					ret = $scope.generateAdditional( "plane", [ width || 1, height || 1, material || "#ffffff" ]);

					break;

				/**
				 * Särmiö
				 */
				case "cube":
					ret = $scope.generateAdditional( "cube", [ obj.width, obj.height, obj.depth, obj.color || "#ffffff" ]);

					break;

				/**
				 * Monimutkaisempi JSON-muotoisesti määritelty objekti
				 */
				case "json":

					if (obj.json) {
						// Objekti on määritelty Mallineessa itsessään
						
						ret = initAdditObjByTemplate_type_json( obj.json, obj );

					} else if (obj.source == "url" && obj.source_url) {
						// Objekti on noudettava verkko-osoitteesta
							
						ret = initAdditObjByTemplate_type_url( obj.source_url );
							
					} else if (obj.source == "attachment" && obj.attachment_uid) {
						// Objekti on ladattu Artestiin liitetiedostona
						
						var attachment_uid = obj.attachment_uid.toUpperCase();

						if (attachment_uid.match( /^A7[A-F0-9]{14}$/ )) {

							var url =  "/ajax/attachments/"+ attachment_uid +".json";

							ret = initAdditObjByTemplate_type_url( url );

						}
					}
			}

			if (ret) {

				return $q.when( ret ).then(function( ret ) {

					ret.$setTemplate( template );

					return ret;
				});

			} else {

				Notification.error( "Unable to create the object!" );

			}

			/************/
			
			function initAdditObjByTemplate_type_json( json, obj ) {

				var ret = $scope.generateAdditional( "json", [ json, obj ]);

				ret.$setTemplate( template );

				return ret;
			}

			function initAdditObjByTemplate_type_url( url ) {

				return ObjectLoader.promiseLoad( url ).then(function( object ){

					object.updateMatrix();

					object.updateMatrix();

					obj.json = object.toJSON();

					var nobj = initAdditObjByTemplate_type_json( obj.json, obj );

					delete nobj.opts.json;

					return nobj;
				});
			}
		};

		$scope.renameAdditionalObject = function( obj, title ) {
			obj.title = title || window.prompt( gettextCatalog.getString( "Insert a name to the object" ), obj.title || "" ) || null;
		};
		$scope.removeAdditionalObject = function( obj ) {
			additionalObjectService.removeObject( obj );
		};


		$scope.generateImagePlane = function( img_uid ) {
			var img, plane;

			return $q.when( img_uid || $rootScope.$ArtestUserBarService.OpenFileGalleryModal( true, false, {
				allow_oeuvre_select: false,
				autoselect_uploaded: true,
				limit: 1
			}).then(function(image){
				if (!image) throw false;

				if (image = image[ Object.keys( image )[0] ]) return image.uid;
			})).then(function( img_uid ){
				if (!img_uid) throw "Got no image uid!";

				return $q(function( resolve, reject ) {
					img = new Image();
					img.onload = function() {
						try {
							resolve( img_uid );
						} catch( error ){
							reject( error );
						}
					};
					img.onerror = function( error ){ reject( error ); };
					img.src = "/i/" + img_uid + "?size=200x200^";
				});
			}).then(function( img_uid ){
				var ratio = 1, w = 1, h = 1;

				try {
					ratio = img.naturalHeight / img.naturalWidth;
					h = parseFloat(( w * ratio ).toFixed( 2 ));
				} catch( e ){ } 

				return plane = $scope.generateAdditional( 'plane', [ w, h, img_uid ]);
			}).catch(function( error ){
				if (!error) return;

				console.error( error );
				Notification.error({
					title: "Failed to generate image!",
					message: error.toString()
				});
			});
		};

		/*****************************/

		// Merkitään talteen #selected-object-controller -härveliä varten
		$scope.selected_object = false;


		$scope.$on("onSelectionChanged", function( event, selection ){

			$scope.wall_panel.wall = null;

			$scope.selected_object = true;

			if (selection.length == 0) {

				$scope.selected_object = false;

			} else if (selection.length == 1) {

				$scope.selected_object = selection;

				selection = selection[0];

				if (selection instanceof WallService.AdditionalWall) {
					$scope.wall_panel.wall = selection;
				}
			}
		});

		/*********** WALLS ***********/

		$scope.wall_panel = {
			height : null,
	//		depth  : null,
	//		color  : null,
	//		width  : null
		};

	/*	$scope._selected_wall_height = null;
		$scope._selected_wall_depth  = null;
		$scope._selected_wall_color  = null;
		$scope._selected_wall_width  = null;

		$scope.$watch("wall_panel.wall.height", function(){
			$scope._selected_wall_height = wallsHandlerService.options.additional_wall_default_height;
			try {
				$scope._selected_wall_height = $scope.wall_panel.wall.height;
			} catch( err ){ }
		});
		$scope.$watch("wall_panel.wall.depth", function(){
			$scope._selected_wall_depth = wallsHandlerService.options.additional_wall_default_depth;
			try {
				$scope._selected_wall_depth = $scope.wall_panel.wall.depth;
			} catch( err ){ }
		});

		$scope.$watch("wall_panel.wall.width", function(){
			$scope._selected_wall_width = NaN;
			try {
				$scope._selected_wall_width = $scope.wall_panel.wall.width;
			} catch( err ){ }
		});
		$scope.$watch(function(){
			return $scope.wall_panel.wall && $scope.wall_panel.wall.material && $scope.wall_panel.wall.material.color.getHex() || 0;
		}, function(){
			$scope._selected_wall_color = "#ffffff";
			try {
				$scope._selected_wall_color = "#" + $scope.wall_panel.wall.material.color.getHexString();
			} catch( err ){ }
		});
		$scope.wallHeightChanged = function( val ){
			if( isNaN(parseFloat( val ))) return;

			$scope.wall_panel.wall.setHeight( val );
			$scope._selected_wall_height = $scope.wall_panel.wall.width;
		};
		$scope.wallWidthChanged = function( val ){
			if( isNaN(parseFloat( val ))) return;

			$scope.wall_panel.wall.setWidth( val );
			$scope._selected_wall_width = $scope.wall_panel.wall.width;
		};
		$scope.wallColorChanged = function( val ){
			if( val[0] != "#" ) val = "#"+val;
			$scope.wall_panel.wall.setColor( val );
		};
		$scope.wallDepthChanged = function( val ){
			$scope.wall_panel.wall.setDepth( val );
		};*/

		// @TODO: Siirrä omaan directiveen 
		(function(){

			$scope.wallsHandler = wallsHandlerService;

			$scope.initiateNewWall = function(){
				entitySelectionService.selected_entity = null;
				wallsHandlerService.$$createNew = true;
				$scope.wall_panel.wall = {};
				HUDService.refreshStateIndicator();
			};

			$scope.resetNewWall = function(){
				wallsHandlerService.$$createNew = false;
				$scope.wall_panel.wall = null;
				HUDService.refreshStateIndicator();
			};

			$scope.genWallName = function( wall, $index ) {

				var title = wall.title || ($index == null ? "" : ("Seinä #" + $index));

				if (title) {
					if (wall.isAdditionalWall) {
						title = gettextCatalog.getString( "AdditionalWall" ) + " '" + title + "'";
						
					}
				} else {
					if (wall.isAdditionalWall) {
						title = gettextCatalog.getString( "AdditionalWall" );
					}
				}

				return title;
			};

			$scope.lookAtWall = function( wall ){
				player.adjustToLookMesh( wall.mesh, 3 );
				wall.showHelpers();
			};

			$scope.renameWall = function( wall ){
				var title = window.prompt( gettextCatalog.getString( "Insert a name to the wall" ), wall.title || "" );
				if( title == null ) return;

				if( wall.title = title || null ){
					var _dupl = false;
					for( var uuid in $scope.walls ) if( wall.uuid != uuid && $scope.walls[uuid].title == wall.title ) _dupl = $scope.walls[ uuid ];
					if( _dupl ) console.warn( "An other wall have a same name '"+ wall.title +"'", _dupl );
				}
			};

			$scope.checkOeuvresOnWall = function( wall ){
				entitySelectionService.selected_entity = Object.keys(wall.oeuvres).map(function( i ){ return wall.oeuvres[i]; });
			};


			// @TODO: Ei käytössä?
			$scope.unselectAdditionalWall = function(){
				return wallsHandlerService.unselectAdditionalWall();
			};

			// @TODO: Ei käytössä?
			$scope.removeSelectAdditionalWall = function(){
				var uuid = $scope.wall_panel.wall && $scope.wall_panel.wall.uuid;
				if( uuid ){
					return wallsHandlerService.removeAdditionalWall( uuid );
				}
			};
		})();

		/********************/
		
		(function() {
			$scope.onNewSpherical360SetupImageChanged = function( event ) {
				var files = event.target.files;
				var errors = [];

				var setups = Array.prototype.map.call( files, function( file ) {

					return ArtestUserAssets.uploadImage( file ).then(function( response ) {

						if (!response || !response.uid) throw "Uploading failed!";
							
						return new Spherical360Setup( null, {
							name      : file.name || ("image "+file.size+" bytes"),
							image_uid : response.uid
						});

					}).catch(function( error ) {

						console.error( error );

						errors.push( error );

					});
				});

				$q.all( setups ).then(function( setups ) {

					setups = setups.filter(function( setup ) {
						return setup;
					});

					return onSpherical360SetupsAdded( setups, errors );
				});

				function spherical360SetupFromDataUri( file ) {
					return $q(function( resolve, reject ) {

						var reader = new FileReader();

						reader.readAsDataURL(file);

						reader.onload = function () {
							try {
								resolve( new Spherical360Setup( reader.result, {
									name: file.name
								}));
							} catch (error) {
								reject( error );
							}
						};

						reader.onerror = reject;

					});
				}
			}

			$scope.addSpherical360SetupImageFromUrl = async function( image_url ) {

				let setups = [], errors = [];

				try {
					if (!image_url) {
						image_url = window.prompt( 'Anna verkko-osoite:' );
					}

					if (!image_url) return console.warn( 'no image_url given. Aborted!' );

					if (!(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/).test( image_url )) {
						throw new Error( "Invalid image_url '" + image_url + "'. Does not look like URL" );
					}

					let textureLoader = /* new TextureLoader() */ getTextureLoader();

					let texture = await new Promise(( resolve, reject ) => {
						textureLoader.load( image_url, resolve, null, reject );
					});

					let name = image_url.substring( image_url.lastIndexOf('/') + 1 );
					
					setups.push( new Spherical360Setup( null, { name, image_url }));

				} catch (error) {
					errors.push( error );
					console.error( error );
					debugger;
				}

				return onSpherical360SetupsAdded( setups, errors );
			}

			function onSpherical360SetupsAdded( setups, errors = [] ) {

				if (errors.length > 0) {
					Notification.error({
						title: "Failed to use "+errors.length+" images!",
						message: "Ignored some files."
					});
				}

				if (setups.length == 0) {
					return Notification.info({
						title: "No setups added!"
					});
				}

				var prev_count = spherical360SetupService.setups.length;

				for (var i = 0; i < setups.length; i++) {
					setups[i].position.x = (spherical360SetupService.setups.length + 1) * 1000;
					spherical360SetupService.add( setups[i] );
				}

				Notification.success({
					title: "Added "+setups.length+" setups!"
				});

				if (prev_count == 0) {
					spherical360SetupService.attachPlayer( spherical360SetupService.setups[0] );
				}

				spherical360SetupService.$$creatingNewSpherical360Setup = false;
			}

			$scope.addNewSpherical360Setup = function( event ) {
				debugger;
			}

			$scope.renameSpherical360Setup = function( setup ) {

				var name = window.prompt( "Anna 360-näkymälle nimi",  setup.name || "" );

				if (angular.isString( name )) {
					setup.name = name;
				}
			}

			$scope.removeSpherical360Setup = function( setup ) {

				if (!window.confirm( "Oletko varma, että haluat poistaa tämän 360-näkymän?" )) return;

				var setup = spherical360SetupService.setups[ setup.uuid || setup ];

				if (spherical360SetupService.setups.length == 1) {
					return window.alert( "NOT_IMPLEMENTED! Ainoata 360-näkymää ei voi poistaa!" );
				} else {
					if (setup == spherical360SetupService.setupPlayerAttachedTo) {
						if (setup == spherical360SetupService.setups[0]){
							spherical360SetupService.attachPlayer( spherical360SetupService.setups[1] );
						} else {
							spherical360SetupService.attachPlayer( spherical360SetupService.setups[0] );
						}
					}
				}

				spherical360SetupService.remove( setup );
			}
		})();

		/********************/

		$scope.$on("$destroy", function(){
			console.log("view.game-scene.controls :: $on('$destroy')");
		});
	}
}
